import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  invitationInviteReplyRoute,
  withdrawApplicationRoute,
} from '@features/applicant';
import { applicantApplicationsKey } from '@features/applications';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type UseInvitationReplyProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useInvitationReply = ({
  setErrorText,
}: UseInvitationReplyProps) => {
  const client = useQueryClient();

  const {
    mutate: replyToInterviewRequest,
    isLoading: isReplyToInterviewRequestLoading,
  } = useMutation({
    mutationFn: (variables: { calendar_id: number; response: 1 | 2 }) =>
      axiosInstance
        .post(invitationInviteReplyRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([applicantApplicationsKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    replyToInterviewRequest,
    isReplyToInterviewRequestLoading,
  };
};
